import { createSlice } from "@reduxjs/toolkit";

// Helper function to create initial tab state for second table
const createInitialSecondTabState = () => ({
    data: [],
    loading: false,
    error: false,
    selectedRows: [],
    lastUpdated: null,
    // Search functionality state
    searchData: {
        MSIID: '',
        Carrier: '',
        Account: '',
        Group: '',
        MemberID: ''
    },
    isSearchClicked: false,
    showAll: false,
    inputError: {
        MSIID: false,
        Carrier: false,
        Account: false,
        Group: false,
        MemberID: false
    },
    // Databricks job state
    jobLoading: false,
    jobStatus: null,
    jobRunId: null,
    jobId: null,
    jobNumberInJob: null,
    jobErrorMessage: null
});

// Initial state with 10 tabs for second table (added COCA Other tab)
const initialState = {
    tabs: Array.from({ length: 10 }, () => createInitialSecondTabState())
};

const reportsTabSecondTableSlice = createSlice({
    name: 'reportsTabSecondTable',
    initialState,
    reducers: {
        setSelectedRows: (state, action) => {
            const { tabIndex, selectedRows } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].selectedRows = selectedRows;
            }
        },
        clearSecondTableData: (state, action) => {
            const { tabIndex } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].data = [];
                state.tabs[tabIndex].selectedRows = [];
                state.tabs[tabIndex].error = false;
            }
        },
        resetError: (state, action) => {
            const { tabIndex } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].error = false;
            }
        },
        updateSearchData: (state, action) => {
            const { tabIndex, field, value } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].searchData[field] = value;
                // Clear error for this field when user types
                if (state.tabs[tabIndex].inputError[field]) {
                    state.tabs[tabIndex].inputError[field] = false;
                }
            }
        },
        setSearchInputError: (state, action) => {
            const { tabIndex, field, hasError } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].inputError[field] = hasError;
            }
        },
        resetSearchData: (state, action) => {
            const { tabIndex } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].searchData = {
                    MSIID: '',
                    Carrier: '',
                    Account: '',
                    Group: '',
                    MemberID: ''
                };
                state.tabs[tabIndex].inputError = {
                    MSIID: false,
                    Carrier: false,
                    Account: false,
                    Group: false,
                    MemberID: false
                };
                state.tabs[tabIndex].isSearchClicked = false;
                state.tabs[tabIndex].showAll = false;
            }
        },
        setShowAll: (state, action) => {
            const { tabIndex, showAll } = action.payload;
            if (state.tabs[tabIndex]) {
                state.tabs[tabIndex].showAll = showAll;
                state.tabs[tabIndex].isSearchClicked = false;
            }
        }
    },
});

export const {
    setSelectedRows,
    clearSecondTableData,
    resetError,
    updateSearchData,
    setSearchInputError,
    resetSearchData,
    setShowAll
} = reportsTabSecondTableSlice.actions;

export default reportsTabSecondTableSlice.reducer;
